import { useCallback, useMemo } from 'react';
import NeoTooltip from "../design/design_components/neo/overlay/NeoTooltip.base";

export default function Circle(props) {
  
  const calculeCoords = useCallback((size, coord_x, coord_y) => {
    const scaleFactorY = (props.img.clientHeight - props.img.spacingVertical) / props.img.naturalHeight;
    const scaleFactorX = (props.img.clientWidth - props.img.spacingHorizontal) / props.img.naturalWidth;
    const mediaSize = Math.round(size / 2);
    return {
      coord_x: coord_x * scaleFactorX - mediaSize,
      coord_y: coord_y * scaleFactorY - mediaSize,
    }
  }, [props.img]);

  const size = props.size ?? 22;
  const { coord_x, coord_y } = useMemo(() => calculeCoords(size, props.coord_x, props.coord_y), [props.img, size, props.coord_x, props.coord_y]);
  const background = `rgba(${props.color}, 0.5)`;
  const border = `thin solid rgb(${props.color})`;

  return (<>
    <div key={props.id}
      id={`circle-${props.id}`}
      style={{
        position: 'absolute',
        top: `${coord_y.toFixed(2)}px`,
        left: `${coord_x.toFixed(2)}px`,
        width: `${size}px`,
        height: `${size}px`,
        background,
        border,
        borderRadius: '50%',
        transition: 'width .75s, height .75s',
      }}
    >
    </div>
    {props.tooltip &&
      <NeoTooltip target={`#circle-${props.id}`} position="bottom">
        <p>{props.tooltip}</p>
      </NeoTooltip>
    }
  </>);
}